import { useMemo, useState } from "react"
import { Platform } from "react-native"
import { useRecoilValue } from "recoil"
import { deviceTokenState } from "src/recoil/atoms/account/deviceTokenState"

export const usePushSettingsData = () => {
  const deviceToken = useRecoilValue(deviceTokenState) ?? ""
  const [pushActiveSections, setPushActiveSections] = useState<number[]>([0])
  const showPushSetting = useMemo(() => Platform.OS !== "web", [])

  return {
    deviceToken: Array(deviceToken),
    pushActiveSections,
    setPushActiveSections,
    showPushSetting,
  }
}
